// @flow
import type { IntegrationJob } from 'api/orgAdmin';
import type { Action } from '../../actions/orgDashboard/integrations';

export type Integrations = {
  jazzhr?: {
    isFetching: boolean,
    jobs: Array<IntegrationJob>
  },
  greenhouse?: {
    isFetching: boolean,
    jobs: Array<IntegrationJob>
  }
};

export type State = {
  byId: {
    [string]: Integrations
  }
};

const initialState = {
  byId: {}
};

export default function integrations(
  state: State = initialState,
  action: Action
) {
  switch (action.type) {
    case 'FETCH_INTEGRATION_ACTION': {
      const orgIntegrations = { ...state.byId[action.orgId] };
      orgIntegrations[action.integrationType] = {
        jobs:
          orgIntegrations && orgIntegrations[action.integrationType]
            ? orgIntegrations[action.integrationType].jobs
            : [],
        isFetching: true
      };
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.orgId]: orgIntegrations
        }
      };
    }
    case 'FETCH_INTEGRATION_FAILURE_ACTION': {
      const orgIntegrations = { ...state.byId[action.orgId] };
      orgIntegrations[action.integrationType] = {
        jobs: [],
        isFetching: false
      };
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.orgId]: orgIntegrations
        }
      };
    }
    case 'FETCH_INTEGRATION_SUCCESS_ACTION': {
      const orgIntegrations = { ...state.byId[action.orgId] };
      orgIntegrations[action.integrationType] = {
        jobs: action.jobs,
        isFetching: false
      };
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.orgId]: orgIntegrations
        }
      };
    }
    default:
      // this causes a flow error if there are any unhandled actions
      (action: empty); // eslint-disable-line no-unused-expressions
      return state;
  }
}
